import React from 'react'
import PropTypes from 'prop-types'
import {ListGroup as RmwcListGroup} from '@rmwc/list'
import '@rmwc/list/styles'

const DrawerListGroup = ({children, ...otherProps}) => <RmwcListGroup {...otherProps}>{children}</RmwcListGroup>

DrawerListGroup.propTypes = {
  children: PropTypes.any
}

export {DrawerListGroup}
